import { render } from "./WelcomeIneligible.vue?vue&type=template&id=307eba1d"
import script from "./WelcomeIneligible.vue?vue&type=script&lang=js"
export * from "./WelcomeIneligible.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__